import React from 'react';
import { QuickFiltersProps } from '../types';

const QuickFilters: React.FC<QuickFiltersProps> = ({ filters, onChange }) => {
  const handleFilterToggle = (filterId: string) => {
    const updatedFilters = filters.map((filter) =>
      filter.id === filterId
        ? { ...filter, selected: !filter.selected }
        : filter
    );

    onChange(updatedFilters);
  };

  return (
    <div className={`flex gap-x-2`}>
      {filters.map((filter) => {
        return (
          <button
            key={filter.id}
            type='button'
            aria-pressed={filter.selected}
            onClick={() => handleFilterToggle(filter.id)}
            className={`rounded border text-secondary-darker border-secondary-lighter px-2 py-1 text-sm font-semibold focus:outline-none focus-visible:outline-none focus-visible:bg-secondary-lightest-two hover:bg-secondary-lightest-two focus-visible:shadow-sm hover:shadow-sm ${
              filter.selected
                ? 'bg-secondary-lightest-two border-secondary-dark hover:bg-secondary-light focus-visible:bg-secondary-light'
                : ''
            } disabled:border-primary-lighter-two disabled:bg-neutral-lightest-two disabled:text-neutral disabled:cursor-not-allowed`}
          >
            {filter.label}
          </button>
        );
      })}
    </div>
  );
};

export default QuickFilters;
